// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const FormLabelRoot = styled.div`
  margin-bottom: 2rem;
`;

export const FormLabelContent = styled.div`
  max-width: 36rem;
`;

export const FormLabelTitle = styled.label`
  font-size: 0.72rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const FormLabelDescription = styled.p`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;
